import React, { useState } from "react";
import { Link } from "react-router-dom";
// import MobileMenuContent from "../common/header/menu/MobileMenuContent";
import Menu from "./Menu";
import logoPowerBizzHeader from "../../../assets/images/logo/logoPowerBizzHeader.webp";
import usericon from "../../../assets/images/icon/user.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import TagManager from "react-gtm-module";

const Header = ({ className = "" }) => {
 const [navbar, setNavbar] = useState(false);
 const changeBackground = () => {
  if (window.scrollY >= 95) {
   setNavbar(true);
  } else {
   setNavbar(false);
  }
 };
 const handleButtonClick = (category, action, label) => {
  TagManager.dataLayer({
   dataLayer: {
    event: category,
    category: category,
    action: action,
    label: label,
   },
  });
 };

 window.addEventListener("scroll", changeBackground);
 return (
  <div>
   {/* <h5 className="w-full p-3 text-center font-[avenir] ztext-base text-white bg-black ">
    Campaña de $1 por el primer mes para todo el Perú y México
   </h5> */}
   <header
    className={`theme-main-menu sticky-menu fixed ${
     navbar ? "" : ""
    }`}
   >
    <div className="inner-content">
     <div className="d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center w-0 lg:w-1/3">
       <nav className="navbar navbar-expand-lg">
        <button
         className="navbar-toggler d-block d-lg-none"
         type="button"
         data-bs-toggle="collapse"
         data-bs-target="#navbarNav"
         aria-controls="navbarNav"
         aria-expanded="false"
         aria-label="Toggle navigation"
        >
         <span></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
         <Menu />
        </div>
       </nav>
      </div>
      <div
       className="w-full lg:w-1/3 flex md:justify-center"
       onClick={() =>
        handleButtonClick("Header", "clic en boton", "Home PowerBizz")
       }
      >
       <Link to="/">
        <LazyLoadImage
         src={logoPowerBizzHeader}
         alt="brand identify"
         width="200"
        />
       </Link>
      </div>
      <div className="d-none d-lg-block w-1/3">
       <div className="flex justify-end gap-3">
        <a
         href={"https://panel.powerbizz.com"}
         target="_blank"
         className="flex justify-center items-center gap-2"
        >
         <LazyLoadImage src={usericon} alt="user" />
         <label
          className="cursor-pointer"
          style={{ fontFamily: "avenirblack", color: "#8163FF" }}
         >
          Iniciar sesión
         </label>
        </a>
        <Link
         to="/nueva-tienda"
         style={{
          fontFamily: "avenirblack",
          color: "#8163FF",
          border: "2px solid #8163FF",
          padding: 5,
         }}
        >
         Crear tienda
        </Link>
       </div>
      </div>
     </div>
    </div>
   </header>
  </div>
 );
};

export default Header;
